(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gft-ds-footer"]) return;
  try {
    
(() => {
  const mq = matchMedia('(max-width: 760px)');
  const groups = () => document.querySelectorAll('.ds-footer__gruppe');
  const apply = () => groups().forEach(d => { d.open = !mq.matches; });
  document.addEventListener('click', e => {
    const summary = e.target.closest('.ds-footer__gruppe > summary');
    if (summary && !mq.matches) e.preventDefault();
  });
  apply();
  mq.addEventListener('change', apply);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gft-ds-produkt"]) return;
  try {
    
function initGftPurchase(scope=document){
  const pdp=scope.querySelector('[data-gft-pdp]');
  if(!pdp||pdp.dataset.enhanced)return;
  pdp.dataset.enhanced='true';
  const buy=pdp.querySelector('[name="add"]');
  const form=buy?.form;
  const sticky=pdp.parentElement.querySelector('[data-gft-sticky]');
  const stickyButton=sticky?.querySelector('button');
  let needSize=pdp.dataset.needsSize==='true';
  let selectionPending=false;
  let colourPending=false;
  const quantity=form?.querySelector('[name="quantity"]');
  const reviewStateKey='gft-review-return';
  try{
    const saved=JSON.parse(sessionStorage.getItem(reviewStateKey)||'null');
    sessionStorage.removeItem(reviewStateKey);
    if(saved&&Date.now()-saved.time<60000&&saved.path===location.pathname&&saved.variant===new URL(location.href).searchParams.get('variant')&&quantity&&Number.isInteger(saved.quantity)&&saved.quantity>0){const amount=Math.min(20,saved.quantity);quantity.value=String(amount);const group=quantity.closest('[data-ds-menge]');const output=group?.querySelector('output');if(output)output.textContent=String(amount);const minus=group?.querySelector('[data-ds-schritt="-1"]');const plus=group?.querySelector('[data-ds-schritt="1"]');if(minus)minus.disabled=amount===1;if(plus)plus.disabled=amount===20;quantity.dispatchEvent(new Event('change',{bubbles:true}));}
  }catch{}
  const lockChoice=locked=>{
    const choice=pdp.querySelector('.gft-shirt-choice');
    choice?.classList.toggle('gft-choice-loading',locked);
    choice?.querySelectorAll('a').forEach(a=>{if(locked)a.setAttribute('aria-disabled','true');else a.removeAttribute('aria-disabled')});
    const status=pdp.querySelector('[data-selection-status]');if(status)status.hidden=!locked;
  };
  const choose=()=>{const target=pdp.querySelector('.gft-shirt-choice__sizes a');target?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'center'});target?.focus({preventScroll:true})};
  form?.addEventListener('submit',event=>{if(needSize||selectionPending){event.preventDefault();event.stopImmediatePropagation();if(!selectionPending)choose()}},true);
  stickyButton?.addEventListener('click',()=>{if(selectionPending)return;if(needSize){choose();return}if(!buy.disabled&&buy.getAttribute('aria-disabled')!=='true')buy.click()});
  if(buy&&sticky){
    const update=()=>{const rect=buy.getBoundingClientRect();const early=!pdp.closest('.gft-premium-focus')&&document.body.classList.contains('gft-product-calm')&&matchMedia('(max-width:760px)').matches;sticky.hidden=rect.bottom>0&&(!early||rect.top<innerHeight);stickyButton.disabled=selectionPending||(needSize?false:buy.disabled||buy.getAttribute('aria-disabled')==='true')};
    const observer=new IntersectionObserver(update);observer.observe(buy);
    let queued=false;const onScroll=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;update()})};window.addEventListener('scroll',onScroll,{passive:true});
    const mutation=new MutationObserver(update);mutation.observe(buy,{attributes:true,attributeFilter:['disabled','aria-disabled']});
    update();
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(pdp)){observer.disconnect();mutation.disconnect();window.removeEventListener('scroll',onScroll)}},{once:true});
  }
  const initialProductUrl=pdp.dataset.productUrl;
  const reviewRegion=document.getElementById(pdp.dataset.reviewAnchor);
  const initialReviewDisplay=reviewRegion?.style.display||'';
  const reviewLink=pdp.parentElement.querySelector('[data-gft-review-link]');
  const openColourReviews=event=>{
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const link=event.target.closest('a');if(!link)return;
    event.preventDefault();
    if(selectionPending)return;
    const target=new URL(link.href,location.href);
    if(!needSize){
      target.searchParams.set('variant',form.querySelector('input[name="id"]').value);
      try{sessionStorage.setItem(reviewStateKey,JSON.stringify({path:target.pathname,variant:target.searchParams.get('variant'),quantity:Number(quantity?.value||1),time:Date.now()}));}catch{}
    }
    if(target.pathname===location.pathname&&target.search===location.search){history.replaceState(history.state,'',target);location.reload();}
    else location.assign(target.href);
  };
  reviewLink?.addEventListener('click',openColourReviews);
  pdp.addEventListener('click',event=>{if(pdp.dataset.productUrl!==initialProductUrl&&event.target.closest('.ds-pdp__rating a'))openColourReviews(event)});
  let selectionRequest;
  pdp.addEventListener('click',async event=>{
    const link=event.target.closest('.gft-shirt-choice:not(.gft-shirt-choice--compact) a');
    if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!form||!buy)return;
    const destination=new URL(link.href,location.href);
    if(destination.origin!==location.origin)return;
    const sectionRoot=pdp.closest('.shopify-section');
    const sectionId=sectionRoot?.id.replace('shopify-section-','');
    if(!sectionId)return;
    event.preventDefault();
    if(buy.classList.contains('loading')||colourPending)return;
    const sizeClick=!!link.closest('.gft-shirt-choice__sizes');
    selectionRequest?.abort();
    const request=new AbortController();selectionRequest=request;
    colourPending=destination.pathname!==new URL(pdp.dataset.productUrl,location.origin).pathname;
    lockChoice(colourPending);
    selectionPending=true;buy.disabled=true;if(stickyButton)stickyButton.disabled=true;
    pdp.setAttribute('aria-busy','true');
    const requestUrl=new URL(destination);requestUrl.searchParams.set('section_id',sectionId);
    const timeout=setTimeout(()=>{if(selectionRequest===request){request.abort();location.assign(destination.href)}},15000);
    try{
      const response=await fetch(requestUrl,{signal:request.signal});
      if(!response.ok)throw new Error('Variant section unavailable');
      const html=await response.text();
      if(request.signal.aborted)return;
      const doc=new DOMParser().parseFromString(html,'text/html');
      const next=doc.querySelector('[data-gft-pdp]');
      const nextChoice=next?.querySelector('.gft-shirt-choice');
      const nextPrice=next?.querySelector('.ds-pdp__preis');
      const nextInput=next?.querySelector('input[name="id"]');
      const nextBuy=next?.querySelector('[name="add"]');
      const nextSticky=doc.querySelector('[data-gft-sticky]');
      const nextImage=next?.querySelector('[data-ds-hauptbild]');
      const nextThumbs=next?.querySelector('.ds-pdp__daumen');
      const currentChoice=pdp.querySelector('.gft-shirt-choice');
      const currentInput=form.querySelector('input[name="id"]');
      const requestedVariant=destination.searchParams.get('variant');
      const productChanged=next?.dataset.productUrl!==pdp.dataset.productUrl;
      if(!nextChoice||!nextPrice||!nextBuy?.querySelector('span')||!nextSticky||!currentChoice||!currentInput||!nextInput?.value||!next?.dataset.productId||new URL(next.dataset.productUrl,location.origin).pathname!==destination.pathname)throw new Error('Product state incomplete');
      if(requestedVariant&&(nextInput.value!==requestedVariant||next.dataset.needsSize!=='false'))throw new Error('Variant state incomplete');
      if(!requestedVariant&&next.dataset.needsSize!=='true')throw new Error('Size choice missing');
      if(productChanged&&!reviewRegion&&document.querySelector('.jdgm-review-widget'))throw new Error('Review region unavailable');
      if(productChanged&&(!nextImage||!nextThumbs||!pdp.querySelector('.ds-pdp__daumen')))throw new Error('Gallery state incomplete');
      const nextGuide=next.querySelector('.gft-size-dialog');
      const nextGuideButton=next.querySelector('[data-size-open]');
      if(pdp.querySelector('.gft-size-dialog')&&(!nextGuide||!nextGuideButton))throw new Error('Size guide incomplete');
      const scrollPosition={top:window.scrollY,left:window.scrollX,behavior:'instant'};
      currentInput.value=nextInput.value;currentInput.disabled=nextInput.disabled;
      const productIdInput=form.querySelector('[name="product-id"]');
      if(productIdInput)productIdInput.value=next.dataset.productId;
      pdp.querySelectorAll('.ds-pdp__preis').forEach(price=>{price.innerHTML=nextPrice.innerHTML});
      currentChoice.replaceWith(nextChoice);
      buy.querySelector('span').textContent=nextBuy.querySelector('span').textContent;
      buy.querySelector('span').className=nextBuy.querySelector('span').className;
      buy.disabled=nextBuy.disabled;buy.removeAttribute('aria-disabled');
      form.closest('product-form')?.handleErrorMessage?.();
      needSize=next.dataset.needsSize==='true';pdp.dataset.needsSize=next.dataset.needsSize;
      pdp.querySelector('.gft-size-prompt')?.remove();
      const nextPrompt=next.querySelector('.gft-size-prompt');
      if(nextPrompt)form.closest('product-form').before(nextPrompt);
      if(nextGuide&&nextGuideButton){pdp.querySelector('.gft-size-dialog')?.replaceWith(nextGuide);pdp.querySelector('[data-size-open]')?.replaceWith(nextGuideButton);}
      if(sticky){sticky.querySelector('div').innerHTML=nextSticky.querySelector('div').innerHTML;stickyButton.textContent=nextSticky.querySelector('button').textContent;stickyButton.disabled=needSize?false:nextBuy.disabled;}
      if(productChanged){
        const currentImage=pdp.querySelector('[data-ds-hauptbild]');
        for(const attr of ['src','srcset','sizes','alt','width','height']){if(nextImage.hasAttribute(attr))currentImage.setAttribute(attr,nextImage.getAttribute(attr));else currentImage.removeAttribute(attr);}
        pdp.querySelector('.ds-pdp__daumen').replaceWith(nextThumbs);
        pdp.dispatchEvent(new Event('gft:gallery-change'));
        for(const selector of ['.ds-pdp__lead','.gft-pdp-disclosures','.ds-pdp__kopf']){const old=pdp.querySelector(selector),fresh=next.querySelector(selector);if(old&&fresh)old.replaceWith(fresh);}
        const oldRating=pdp.querySelector('.ds-pdp__rating'),freshRating=next.querySelector('.ds-pdp__rating');
        if(oldRating)oldRating.remove();if(freshRating)pdp.querySelector('.ds-pdp__preis--info').before(freshRating);
        for(const step of ['-1','1']){const button=pdp.querySelector(`[data-ds-schritt="${step}"]`);const label=next.querySelector(`[data-ds-schritt="${step}"]`)?.getAttribute('aria-label');if(button&&label)button.setAttribute('aria-label',label);}
        document.title=next.dataset.productTitle;
        const canonical=document.querySelector('link[rel="canonical"]');if(canonical)canonical.href=new URL(next.dataset.productUrl,location.origin).href;
      }
      const originalProduct=next.dataset.productUrl===initialProductUrl;
      if(reviewRegion)reviewRegion.style.display=originalProduct?initialReviewDisplay:'none';
      const reviewUrl=new URL(destination);reviewUrl.hash=pdp.dataset.reviewAnchor;
      if(reviewLink){reviewLink.hidden=originalProduct;reviewLink.querySelector('a').href=reviewUrl.href;}
      const ratingLink=pdp.querySelector('.ds-pdp__rating a');if(ratingLink)ratingLink.href=originalProduct?`#${pdp.dataset.reviewAnchor}`:reviewUrl.href;
      const oldSchema=sectionRoot.querySelector('script[type="application/ld+json"]');
      const nextSchema=doc.querySelector('script[type="application/ld+json"]');
      if(oldSchema&&nextSchema)oldSchema.textContent=nextSchema.textContent;
      pdp.dataset.productUrl=next.dataset.productUrl;pdp.dataset.productId=next.dataset.productId;pdp.dataset.productTitle=next.dataset.productTitle;
      history.replaceState(history.state,'',destination);
      nextChoice.querySelector(sizeClick?'.gft-shirt-choice__sizes [aria-current]':'.gft-shirt-choice__options:not(.gft-shirt-choice__sizes) [aria-current]')?.focus({preventScroll:true});
      window.scrollTo(scrollPosition);
    }catch(error){
      if(error.name!=='AbortError')location.assign(destination.href);
    }finally{
      clearTimeout(timeout);
      if(selectionRequest===request){selectionPending=false;colourPending=false;lockChoice(false);pdp.removeAttribute('aria-busy');}
    }
  });
  const stage=pdp.querySelector('.ds-pdp__bild');
  let thumbs=[...pdp.querySelectorAll('[data-ds-daumen]')];
  const image=stage?.querySelector('img');
  if(stage&&thumbs.length>1){
    const nav=document.createElement('div');nav.className='gft-gallery-nav';
    const prev=document.createElement('button');prev.type='button';prev.textContent='‹';prev.setAttribute('aria-label',pdp.dataset.previousImage);
    const next=document.createElement('button');next.type='button';next.textContent='›';next.setAttribute('aria-label',pdp.dataset.nextImage);
    const count=document.createElement('output');count.setAttribute('aria-live','polite');
    nav.append(prev,count,next);stage.after(nav);
    let index=Math.max(0,thumbs.findIndex(t=>t.getAttribute('aria-pressed')==='true'));
    const show=i=>{index=(i+thumbs.length)%thumbs.length;const t=thumbs[index];image.src=t.dataset.dsSrc;image.srcset=t.dataset.dsSrcset||'';image.alt=t.dataset.dsAlt||'';thumbs.forEach(b=>b.setAttribute('aria-pressed',String(b===t)));count.textContent=`${index+1} / ${thumbs.length}`;};
    pdp.addEventListener('click',event=>{const thumb=event.target.closest('[data-ds-daumen]');const i=thumbs.indexOf(thumb);if(i>=0)show(i)});
    pdp.addEventListener('gft:gallery-change',()=>{thumbs=[...pdp.querySelectorAll('[data-ds-daumen]')];nav.hidden=thumbs.length<2;if(thumbs.length)show(0)});
    prev.addEventListener('click',()=>show(index-1));next.addEventListener('click',()=>show(index+1));
    count.textContent=`${index+1} / ${thumbs.length}`;
    let start=null,swiped=false;
    stage.addEventListener('touchstart',e=>{if(e.touches.length!==1)return;start={x:e.touches[0].clientX,y:e.touches[0].clientY};swiped=false},{passive:true});
    stage.addEventListener('touchend',e=>{if(!start)return;const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4){show(index+(dx<0?1:-1));swiped=true}start=null},{passive:true});
    stage.addEventListener('touchcancel',()=>{start=null},{passive:true});
    stage.addEventListener('click',e=>{if(swiped){e.preventDefault();e.stopImmediatePropagation();swiped=false;return}if(e.target===image)stage.querySelector('[data-ds-bild]')?.click()},true);
  }
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initGftPurchase());else initGftPurchase();
document.addEventListener('shopify:section:load',event=>initGftPurchase(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
